var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-media-library__directory"},[_c('span',{on:{"click":function($event){$event.preventDefault();return _vm.open.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-folder-o"}),_vm._v(" "+_vm._s(_vm.directory.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }